console.log("🟢 gift-promo.js caricato");

document.addEventListener("DOMContentLoaded", initGiftPromo);
window.addEventListener("pageshow", initGiftPromo);

function initGiftPromo() {
  console.log("🟠 initGiftPromo chiamato");

  if (!window.location.pathname.includes("/collections/solari-erbolario") && !window.location.pathname.includes("/collections/l-erbolario")) {
    console.log("🚫 Pagina non valida, abort");
    return;
  }

  console.log("✅ Pagina valida: solari-erbolario");

  const PROMO_SKUS = [
    "0086.025", "0086.024", "0086.023", "0086.022", "0086.021",
    "0086.019", "0086.018", "0086.017", "0086.016", "0086.073",
    "0086.013", "0086.012", "0086.011", "0086.010", "0086.216",
    "0086.009", "0086.008", "0086.015", "0086.005", "0086.006",
    "0086.007", "0086.002", "0086.933", "0086.092", "0086.001",
    "0086.950", "0086.949", "0086.897", "0086.555", "0086.497",
    "0086.494", "0086.472", "0086.427", "0086.399", "0086.398",
    "0086.014", "0086.360", "0086.354", "0086.232", "0086.230",
    "0086.229", "0086.228", "0086.218", "0086.215", "0086.214",
    "00086.217",
  ];

  const GIFT_A_VARIANT_ID = 51604550910283; // soglia 29€
  const GIFT_B_VARIANT_ID = 51604543897931; // soglia 49€
  const GIFT_IDS = [GIFT_A_VARIANT_ID, GIFT_B_VARIANT_ID];

  const messageEl = document.getElementById("gift-message");
  const barFill = document.getElementById("gift-bar-fill");
  const stepLabel = document.getElementById("gift-step-label");

  updateCartAndPromo();

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = args[0];
    if (typeof url === "string" && (url.includes("/cart/add") || url.includes("/cart/change"))) {
      console.log("🟡 fetch intercettato:", url);
      setTimeout(updateCartAndPromo, 600);
    }
    return originalFetch.apply(this, args);
  };

  setInterval(updateCartAndPromo, 5000);

  function updateCartAndPromo() {
    console.log("🔄 Chiamata updateCartAndPromo()");
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => handleCart(cart));
  }

  function handleCart(cart) {
    console.log("🛒 Carrello ricevuto:", cart);

    let totalPromo = 0;

    cart.items.forEach((item) => {
      const isPromoProduct = PROMO_SKUS.includes(item.sku);
      if (isPromoProduct && !GIFT_IDS.includes(item.variant_id)) {
        totalPromo += item.line_price / 100;
      }
    });

    console.log("💰 Totale promo:", totalPromo);

    updateProgressBar(totalPromo);

    let giftsToAdd = [];
    if (totalPromo >= 78) {
      giftsToAdd = [GIFT_A_VARIANT_ID, GIFT_B_VARIANT_ID];
    } else if (totalPromo >= 49) {
      giftsToAdd = [GIFT_B_VARIANT_ID];
    } else if (totalPromo >= 29) {
      giftsToAdd = [GIFT_A_VARIANT_ID];
    }

    const currentGiftIds = cart.items
      .filter((i) => GIFT_IDS.includes(i.variant_id))
      .map((i) => i.variant_id);

    const toAdd = giftsToAdd.filter((id) => !currentGiftIds.includes(id));
    const toRemove = currentGiftIds.filter((id) => !giftsToAdd.includes(id));

    toAdd.forEach((variantId) => {
      console.log("➕ Aggiungo regalo:", variantId);
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ quantity: 1, id: variantId }] }),
      });
    });

    cart.items.forEach((item) => {
      if (toRemove.includes(item.variant_id)) {
        console.log("➖ Rimuovo regalo:", item.variant_id);
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });
      }
    });
  }

  function updateProgressBar(totalPromo) {
    if (!messageEl || !barFill || !stepLabel) {
      console.warn("⚠️ Barra non trovata nel DOM");
      return;
    }
  
    let progress = 0;
    let message = "";
    let stepText = "";
  
    if (totalPromo >= 78) {
      progress = 100;
      message = "🎉 Complimenti! Hai sbloccato entrambi i regali: Rinfrescasole e Borsa Mare!";
      stepText = "✅ Obiettivo raggiunto!";
    } else if (totalPromo >= 49) {
      progress = (totalPromo / 78) * 100;
      message = "🎁 Fantastico, hai ottenuto la Borsa Mare in omaggio!";
      stepText = `✨ Ti mancano €${(78 - totalPromo).toFixed(2)} per ricevere entrambi i regali!`;
    } else if (totalPromo >= 29) {
      progress = (totalPromo / 78) * 100;
      message = "🎁 Primo traguardo raggiunto: Hai ottenuto in omaggio il Rinfrescasole!";
      stepText = `🛍️ Ti mancano €${(49 - totalPromo).toFixed(2)} per ricevere la Borsa Mare.`;
    } else {
      progress = (totalPromo / 78) * 100;
      message = "🎁 Aggiungi al carrello i solari per ricevere il tuo omaggio!";
      stepText = `🚀 Ti mancano €${(29 - totalPromo).toFixed(2)} ricevere 1 Rinfrescasole 100ml in regalo.`;
    }
  
    messageEl.innerHTML = message;
    stepLabel.innerText = stepText;
    barFill.style.width = `${Math.min(progress, 100)}%`;
  
    // Attiva checkpoint
    document.querySelectorAll(".checkpoint").forEach((el) => {
      const amount = parseFloat(el.dataset.amount);
      if (totalPromo >= amount) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });
  
    console.log("📊 Barra aggiornata con checkpoint:", progress.toFixed(1) + "%");
  }
}